import { render, staticRenderFns } from "./Workflow-FIF.vue?vue&type=template&id=2a0f37cb&scoped=true&"
import script from "./Workflow-FIF.vue?vue&type=script&lang=js&"
export * from "./Workflow-FIF.vue?vue&type=script&lang=js&"
import style0 from "./Workflow-FIF.vue?vue&type=style&index=0&id=2a0f37cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f37cb",
  null
  
)

export default component.exports